<div class="listview-item bg-lightest mb-3">
  <div class="row w-100">
    <div class="col-6 d-flex align-items-center">
      <base-checkbox
        *ngIf="providerInfo.isCheckBoxAvailable"
        [isChecked]="providerInfo.isSelected"
        (getChange)="onItemSelect($event)"
      ></base-checkbox>
      <base-avatar
        class="ms-7"
        [image]="providerInfo.logo?.data || ''"
        [isCompany]="true"
        [size]="avatarSize.medium"
      ></base-avatar>
      <div
        class="ms-3"
        baseTruncate
      >
        <span class="fw-bold m-0">{{ providerInfo.pspBranch.name }}</span>
        <br />
        <span class="m-0">{{ providerInfo.psp.legalName }}</span>
      </div>
    </div>

    <div class="col-2">
      <i [class]="providerInfo.deliveryType + ' fa-solid delivery-priority fa-circle-' + providerInfo.deliveryType"></i>
    </div>

    <div
      class="col-2"
      baseTruncate
    >
      {{ providerInfo.pspBranch.businessAddress.postCode }} {{ providerInfo.pspBranch.businessAddress.city }}
    </div>

    <div class="col-2">
      <p
        class="m-0"
        baseTruncate
        *ngIf="
          providerInfo.scheduledSentAt && !providerInfo.isPendingToBeSent && !providerInfo.isInquiryClosedBeforeSent
        "
      >
        <span>{{ providerInfo.scheduledSentAt | baseFormatDate: true }}</span>
        <br />
        <span>{{ providerInfo.scheduledSentBy?.firstName }} {{ providerInfo.scheduledSentBy?.lastName }}</span>
      </p>
      <p
        class="text-dark-gray fw-semi-bold m-0"
        baseTruncate
        *ngIf="providerInfo.scheduledSentAt && providerInfo.isPendingToBeSent && !isInquiryClosed"
      >
        <span>{{ providerInfo.scheduledSentAt | baseFormatDate: true }}</span>
        <br />
        <span>{{ providerInfo.scheduledSentBy?.firstName }} {{ providerInfo.scheduledSentBy?.lastName }}</span>
        <br />
        <span>{{ 'placeholders.pending' | translate }}</span>
      </p>
      <p
        class="text-dark-gray fw-semi-bold m-0"
        baseTruncate
        *ngIf="providerInfo.isInquiryClosedBeforeSent"
      >
        <span>{{ 'placeholders.notSent' | translate }}.</span><br />
        <span>{{ 'placeholders.inquiryClosed' | translate }}.</span>
      </p>
      <p
        baseTruncate
        class="text-dark-gray fw-semi-bold m-0"
        *ngIf="!providerInfo.scheduledSentAt"
      >
        {{ 'placeholders.notSelected' | translate }}
      </p>
    </div>
  </div>
</div>
